export const FEATURE_LABELS = {
    dashboard_operational: "Dashboard Operacional",
    dashboard_manager: "Dashboard Gerencial",
    dashboard_financial: "Dashboard Financeiro",
    members_module: "Gestão de Clientes",
    member_financial_tab: "Ficha Aluno: Aba Financeiro",
    member_memberships_tab: "Ficha Aluno: Aba Contratos",
    sales_point: "Ponto de Venda (PDV)",
    debt_payment: "Registro de Dívidas",
    financial_module: "Módulo Financeiro Completo",
    class_management: "Grade de Horários e Turmas",
    planning_module: "Planejamento Pedagógico",
    gamification: "Gamificação (Insígnias)",
    automations: "Automações CRM",
    business_rules: "Regras de Negócio",
    integrations: "Integrações de Canais",
    kiosk: "Módulo Quiosque (Totem)",
    ai_workout_generation: "Criação de Treinos com IA",
    crm_module: "Módulo CRM",
    team_management: "Colaboradores (Equipe)",
    performance_module: "Performance e Avaliações",
    goals_module: "Módulo de Metas",
    workout_creation: "Criação de Treinos",
    media: "Mídias de TV"
};

export const FEATURE_KEYS = Object.keys(FEATURE_LABELS);

export const DEFAULT_PLAN_FORM = {
    name: "",
    basePlanId: "basic",
    monthlyPrice: 197,
    annualPrice: 1997,
    studentLimit: 150,
    userLimit: 5,
    active: true,
    methodologyNeoPrice: 149,
    features: {
        dashboard_operational: true,
        dashboard_manager: true,
        dashboard_financial: false,
        members_module: true,
        member_financial_tab: false,
        member_memberships_tab: true,
        sales_point: false,
        debt_payment: false,
        financial_module: false,
        class_management: true,
        planning_module: true,
        gamification: false,
        automations: false,
        business_rules: false,
        integrations: false,
        kiosk: false,
        ai_workout_generation: false,
        crm_module: false,
        team_management: true,
        performance_module: false,
        goals_module: false,
        workout_creation: true,
        media: false
    },
};
